import { createFileRoute } from '@tanstack/react-router'
import { redirect } from '@ufc/core'
import { selectIsAuthenticated } from '@ufc/domains/auth'
import { DriverTripsSection } from '@ufc/domains/trip-planning'

import type { RouterContext } from '@/main'

export const Route = createFileRoute('/')({
  beforeLoad: ({ context }) => {
    if (!selectIsAuthenticated(context.store.getState())) {
      throw redirect({ to: '/login', replace: true })
    }
  },
  component: DriverTripsSection,
})
